import { createAction } from '@reduxjs/toolkit';
import type * as I from 'core/api/coreApiClient';

export const disableLegacySearchAction = createAction('ui/disableLegacySearch');

export const closeModalAction = createAction('ui/closeModal', (
  modalId?: string,
) => ({
  payload: {
    modalId,
  },
}));

export const resetCloseModalAction = createAction('ui/resetCloseModal');

export const refreshPageAction = createAction('ui/refreshPageAction');

export const resetRefreshPageAction = createAction('ui/resetRefreshPageAction');

export const redirectToPageAction = createAction('ui/redirectToPageAction', (
  url: string,
  replaceInHistory?: boolean,
) => ({
  payload: {
    url,
    replaceInHistory,
  },
}));

export const resetRedirectToPageAction = createAction('ui/resetRedirectToPageAction');

export const closeFullscreenTableAction = createAction('ui/closeFullscreenTable', (
  tableId?: string,
) => ({
  payload: {
    tableId,
  },
}));

export const openFullscreenTableAction = createAction('ui/openFullscreenTable', (
  tableId: string,
) => ({
  payload: {
    tableId,
  },
}));

export const startResizingTableColumnAction = createAction('ui/startResizingTableColumn', (
  columnId?: string,
) => ({
  payload: {
    columnId,
  },
}));

export const stopResizingTableColumnAction = createAction('ui/stopResizingTableColumn');

export const redirectAction = createAction('ui/redirectAction', (
  redirect: I.Redirect,
  responseStatus: number,
) => ({
  payload: {
    redirect,
    responseStatus,
  },
}));

export const openNewWindowAction = createAction('ui/openNewWindow', (
  url: string,
) => ({
  payload: {
    url,
  },
}));

export const copyToClipboardAction = createAction('ui/copyToClipboard', (
  content: string,
  message?: string,
) => ({
  payload: {
    content,
    message,
  },
}));

export const showAppHeaderEnvAction = createAction('ui/showAppHeaderEnvAction');
export const hideAppHeaderEnvAction = createAction('ui/hideAppHeaderEnvAction');

export const activateEditableTableAction = createAction('ui/activateEditableTableAction', (
  tableId: string,
) => ({
  payload: {
    tableId,
  },
}));
export const deactivateEditableTableAction = createAction('ui/deactivateEditableTableAction', (
  tableId: string,
) => ({
  payload: {
    tableId,
  },
}));
